import React from 'react'
import {
  Box,
  Button,
  HStack,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Text,
  VStack,
} from '@chakra-ui/react'

interface HospitalSubFormProps {
  erVisit: boolean | null
  hospitalised: boolean | null
  daysHospitalised: number | null
  onErVisitChange: (value: boolean | null) => void
  onHospitalisedChange: (value: boolean | null) => void
  onDaysHospitalisedChange: (value: number | null) => void
}

const HospitalSubForm: React.FC<HospitalSubFormProps> = ({
  erVisit,
  hospitalised,
  daysHospitalised,
  onErVisitChange,
  onHospitalisedChange,
  onDaysHospitalisedChange,
}) => {
  const handleErYes = () => {
    onErVisitChange(erVisit === true ? null : true)
  }

  const handleErNo = () => {
    onErVisitChange(erVisit === false ? null : false)
  }

  const handleHospYes = () => {
    onHospitalisedChange(hospitalised === true ? null : true)
  }

  const handleHospNo = () => {
    onHospitalisedChange(hospitalised === false ? null : false)
  }

  const handleDaysChange = (_valueStr: string, valueNum: number) => {
    if (isNaN(valueNum)) {
      onDaysHospitalisedChange(null)
      return
    }
    const clamped = Math.max(1, Math.floor(valueNum))
    onDaysHospitalisedChange(clamped)
  }

  return (
    <VStack align='stretch' spacing={4}>
      <Box>
        <Text fontSize='sm' fontWeight='medium' mb={2}>
          Did you visit the emergency room (ER)?
        </Text>
        <HStack spacing={2}>
          <Button
            size='xs'
            variant={erVisit === true ? 'solid' : 'outline'}
            colorScheme='red'
            onClick={handleErYes}
          >
            Yes
          </Button>
          <Button
            size='xs'
            variant={erVisit === false ? 'solid' : 'outline'}
            colorScheme='green'
            onClick={handleErNo}
          >
            No
          </Button>
        </HStack>
      </Box>

      <Box>
        <Text fontSize='sm' fontWeight='medium' mb={2}>
          Were you hospitalised?
        </Text>
        <HStack spacing={2}>
          <Button
            size='xs'
            variant={hospitalised === true ? 'solid' : 'outline'}
            colorScheme='red'
            onClick={handleHospYes}
          >
            Yes
          </Button>
          <Button
            size='xs'
            variant={hospitalised === false ? 'solid' : 'outline'}
            colorScheme='green'
            onClick={handleHospNo}
          >
            No
          </Button>
        </HStack>
      </Box>

      {hospitalised === true && (
        <Box>
          <Text fontSize='sm' fontWeight='medium' mb={2}>
            How many days were you hospitalised?
          </Text>
          <NumberInput
            min={1}
            value={daysHospitalised ?? ''}
            onChange={handleDaysChange}
            size='sm'
            maxW='120px'
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        </Box>
      )}
    </VStack>
  )
}

export default HospitalSubForm
